(function () {
  'use strict';
 
  if (!window.UnifiedTracking) {
    return;
  }
 
  const VERSION = '1.1.0';
 
  const CONFIG =
    window.UnifiedTracking.getConfig() ||
    {};
 
  function currentPath() {
    return String(
      window.location.pathname || '/'
    ).toLowerCase();
  }
 
  function currentPage() {
    return {
      path:
        currentPath(),
 
      title:
        document.title || ''
    };
  }

  function currentPageContext() {
    if (
      window.UnifiedPageContext &&
      typeof window.UnifiedPageContext.getContext === 'function'
    ) {
      return window.UnifiedPageContext.getContext();
    }

    return null;
  }
 
  function currentService() {
    const path =
      currentPath();
 
    const pages =
      CONFIG.pages || {};
 
    for (
      const [service, definition]
      of Object.entries(pages)
    ) {
      const paths =
        definition &&
        Array.isArray(definition.paths)
          ? definition.paths
          : [];
 
      if (
        paths.includes(path)
      ) {
        return service;
      }
    }
 
    return null;
  }
 
  function normalizePhone(phone) {
    if (!phone) {
      return '';
    }
 
    return String(phone)
      .replace(/\D/g, '');
  }
 
  function servicesFromPhone(phone) {
    const normalized =
      normalizePhone(phone);
 
    const matches = [];
 
    if (!normalized) {
      return matches;
    }
 
    const phones =
      CONFIG.phones || {};
 
    for (
      const [service, definition]
      of Object.entries(phones)
    ) {
      const normalizedPhones =
        definition &&
        Array.isArray(
          definition.normalized
        )
          ? definition.normalized
          : [];
 
      if (
        normalizedPhones.includes(
          normalized
        )
      ) {
        matches.push(service);
      }
    }
 
    return matches;
  }
 
  // Compatibilitate cu codul existent
  function serviceFromPhone(phone) {
    const matches =
      servicesFromPhone(phone);
 
    if (matches.length === 1) {
      return matches[0];
    }
 
    return null;
  }
 
  function serviceFromElement(element) {
    if (
      !element ||
      typeof element.closest !==
        'function'
    ) {
      return null;
    }
 
    const container =
      element.closest(
        '[data-ut-service]'
      );
 
    if (!container) {
      return null;
    }
 
    return (
      container.dataset
        .utService ||
      null
    );
  }
 
  function resolveService(
    options = {}
  ) {
    const {
      element = null,
      phone = null
    } = options;
 
    // 1. Declarat explicit in HTML
    const declaredService =
      serviceFromElement(element);
 
    if (declaredService) {
      return declaredService;
    }
 
    // 2. Determinat din URL
    const pageService =
      currentService();
 
    if (
      pageService &&
      pageService !== 'contact'
    ) {
      return pageService;
    }
 
    // 3. Determinat din telefon
    // doar daca rezultatul este unic
    if (phone) {
      const phoneService =
        serviceFromPhone(phone);
 
      if (phoneService) {
        return phoneService;
      }
    }
 
    // 4. Serviciu ambiguu
    return null;
  }
 
  const API = {
    version:
      VERSION,
 
    currentPath:
      currentPath,
 
    currentPage:
      currentPage,
 
    currentPageContext:
      currentPageContext,
 
    currentService:
      currentService,
 
    normalizePhone:
      normalizePhone,
 
    servicesFromPhone:
      servicesFromPhone,
 
    serviceFromPhone:
      serviceFromPhone,
 
    serviceFromElement:
      serviceFromElement,
 
    resolveService:
      resolveService
  };
 
  /*
   * API public utilizat de
   * Unified Dashboard API.
   */
  window.UnifiedDetection =
    API;
 
  /*
   * Compatibilitate cu
   * implementarea existenta.
   */
  window.UnifiedTracking.detect =
    API;
 
  if (CONFIG.debug) {
    console.info(
      '[Unified Detection] Detection initialized',
      {
        version:
          VERSION,
 
        service:
          currentService(),
 
        page:
          currentPage()
      }
    );
  }
})();
